import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {GameManagerInstance} from '../managers/gamemanager.js';

/**
 * Prefetches the scene to make scene.load() instant.
 */
export class PrefetchScene extends Component {
    static TypeName = 'prefetch-scene';

    @property.string('scene2.bin')
    sceneFile = 'Scene2.bin';

    start() {
        const linkEl = document.createElement('link');
        linkEl.rel = 'preload';
        linkEl.href = this.sceneFile;
        linkEl.as = 'fetch';
        linkEl.onload = () => {
            GameManagerInstance.preloaded(this.sceneFile);
        };
        document.head.appendChild(linkEl);
    }
}
